export const THEME_STORAGE_KEY = 'press-theme'
export const DEFAULT_THEME = 'default'

export const themes = {
  default: {
    name: 'Dark Mode',
    variables: {
      '--bg-primary': '#000000',
      '--bg-secondary': '#1c1c1e',
      '--bg-tertiary': '#2c2c2e',
      '--bg-hover': '#3a3a3c',
      '--bg-elevated': '#2c2c2e',
      '--text-primary': '#ffffff',
      '--text-secondary': '#a0a0a0',
      '--text-muted': '#8a8a8e',
      '--accent-primary': '#0ea47a',
      '--accent-secondary': '#5e9be6',
      '--accent-danger': '#ef4444',
      '--accent-warning': '#f59e0b',
      '--border-color': 'rgba(255,255,255,0.04)',
      '--shadow': 'rgba(0, 0, 0, 0.8)',
      '--card-shadow': 'none',
      '--font-body': "'Outfit', sans-serif",
      '--font-heading': "'Outfit', sans-serif",
      '--header-bg': '#1c1c1e',
      '--header-text': '#a0a0a0',
      '--header-brand': '#0ea47a',
      '--header-border': 'rgba(255,255,255,0.06)',
      '--nav-bg': '#1c1c1e',
      '--nav-text': '#8a8a8e',
      '--nav-active': '#0ea47a',
      '--nav-border': 'rgba(255,255,255,0.06)',
      '--input-border': 'rgba(255,255,255,0.10)',
    },
  },
  light: {
    name: 'Light Mode',
    variables: {
      '--bg-primary': '#f2f2f7',
      '--bg-secondary': '#ffffff',
      '--bg-tertiary': '#f0f0f2',
      '--bg-hover': '#e5e5ea',
      '--bg-elevated': '#f0f0f2',
      '--text-primary': '#1c1c1e',
      '--text-secondary': '#2c2c2e',
      '--text-muted': '#48484a',
      '--accent-primary': '#0ea47a',
      '--accent-secondary': '#3b82f6',
      '--accent-danger': '#ef4444',
      '--accent-warning': '#f59e0b',
      '--border-color': 'rgba(0,0,0,0.04)',
      '--shadow': 'rgba(0, 0, 0, 0.06)',
      '--card-shadow': '0 1px 4px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
      '--font-body': "'Outfit', sans-serif",
      '--font-heading': "'Outfit', sans-serif",
      '--header-bg': '#ffffff',
      '--header-text': '#48484a',
      '--header-brand': '#0ea47a',
      '--header-border': 'rgba(0,0,0,0.06)',
      '--header-avatar-bg': 'rgba(14, 164, 122, 0.12)',
      '--header-avatar-text': '#ffffff',
      '--feedback-bg': 'rgba(0, 0, 0, 0.05)',
      '--feedback-border': 'rgba(0, 0, 0, 0.08)',
      '--feedback-text': '#48484a',
      '--feedback-bg-hover': 'rgba(0, 0, 0, 0.08)',
      '--nav-bg': '#ffffff',
      '--nav-text': '#8e8e93',
      '--nav-active': '#0ea47a',
      '--nav-border': 'rgba(0,0,0,0.06)',
      '--input-border': 'rgba(0,0,0,0.12)',
    },
  },
}
